<section class="back-button-container" (click)="onClick()" [id]="uniqueId">
    <section class="icon-container">
        <i class="pi pi-arrow-left icon" [ngClass]="{'grey': greyStyle}"></i>
    </section>
    <section class="text-container" *ngIf="showBackText">
        <span class="text">{{"SHARED.BACK" | translate}}</span>
    </section>
</section>
